const required = true

const incidentTypes = [
  { value: 'fatal', title: 'Fatal' },
  { value: 'doctorOnly', title: 'Doctor Only' },
  { value: 'firstAidOnly', title: 'First Aid Only' },
  { value: 'properyDamager', title: 'Propery Damager' },
  { value: 'nil', title: 'Nil Injury/Damage' }
]

const formFields = [
  { key: 'type', title: 'Report Type', input: 'select', options: ['Injury', 'Incident', 'Near Miss'], class: 'column is-12 uc-words', required },
  { content: 'Personal Details', class: 'column is-12 font-size-120 bold' },
  { key: 'name', required, class: 'column is-6' },
  { key: 'dateOfBirth', input: 'date', class: 'column is-3', required },
  { key: 'sex', input: 'select', options: ['Male', 'Female'], expanded: true, class: 'column is-3 uc-words', required },
  { key: 'phone', title: 'Contact Phone Number', required },
  { key: 'jobTitle', title: 'Occupation/Job Title', required },
  { key: 'tasksPerformed', title: 'Main Tasks Performed', class: 'column is-6', required },
  { key: 'trainingProvided', input: 'select', options: ['Induction', 'Trade/Task Specific', 'Both of the Above', 'Neither of the Above'], class: 'column is-6 uc-words', expanded: true, required },
  { content: 'Incident/Near Miss Details', class: 'column is-12 font-size-120 bold', incidentDetails: true },
  { key: 'dateOfIncident', input: 'datetime', title: 'Date and Time Of Incident/Near Miss', class: 'column is-6', required },
  { key: 'incidentType', title: 'Incident/Near Miss Type', input: 'select', options: incidentTypes, expanded: true, class: 'column is-6 uc-words', required },
  { key: 'nameOfFirstAidProvider', class: 'column is-12' },
  { key: 'natureOfIncident', title: 'Nature of Injury/Near Miss', input: 'textarea', class: 'column is-12', required },
  { key: 'affectecPartOfBody', title: 'What Part of the Body was affected (e.g. head, hand, foot)', input: 'textarea', class: 'column is-12', required },
  { key: 'description', title: 'Description of Incident: (include any particular chemical, product, process, equipment involved or what the worker was doing at the time)', input: 'textarea', class: 'column is-12', required },
  { key: 'contributingFactors', title: 'List any Contributng Factors to the Incident (if applicable)', input: 'textarea', class: 'column is-12' }
]

const investigationFields = [
  { key: 'dateConducted', title: 'Date Investigation Conducted', input: 'date', class: 'column is-6', required },
  { key: 'corectiveAction', title: 'Corrective Action Undertaken to Prevent a Reoccurance of the Incident', input: 'textarea', class: 'column is-12', required },
  { key: 'comments', title: 'Investigating Persons Comments', input: 'textarea', class: 'column is-12' }
]

export {
  formFields,
  incidentTypes,
  investigationFields
}
